// extracted by mini-css-extract-plugin
module.exports = {"editTourContainer":"EditTour_editTourContainer__1Bd5V","editTourBody":"EditTour_editTourBody__3NFHO"};